class RandomItemsOrder extends HTMLElement {
  constructor () {
    super();

    this.items = JSON.parse(this.getAttribute('data-items'));
    this.list = this.querySelector('[data-desktop-list]');
    this.randomItems = Boolean(this.getAttribute('data-random-items'));
    this.limit = this.getAttribute('data-limit-desktop');
    this.mobileLimit = this.getAttribute('data-limit-mobile');
    this.template = this.querySelector('.template');
    this.mobileRows = this.querySelectorAll('.items-row');

    if (!this.items.length || !this.template) return;

    this.shuffledItems = this.randomItems ? this.#randomizeArray(this.items) : this.items;
    this.#buildList();
  }

  #randomizeArray (array) {
    return [...array].sort(() => Math.random() - 0.5);
  }

  #createItem (item) {
    const clone = this.template.cloneNode(true);
    clone.style.display = '';

    const link = clone.querySelector('a');
    const text = clone.querySelector('span');

    if (!link || !text) return null;

    link.href = item.url;
    text.textContent = item.title;

    return clone;
  }

  #buildList () {
    const desktopItems = this.limit
      ? this.shuffledItems.slice(0, this.limit)
      : this.shuffledItems;

    for (const item of desktopItems) {
      const el = this.#createItem(item);
      if (el) this.list.appendChild(el);
    }

    const totalMobile = this.mobileLimit
      ? Math.min(this.shuffledItems.length, this.mobileLimit)
      : this.shuffledItems.length;
    const rowsCount = this.mobileRows.length;

    if (rowsCount === 0) return;

    const basePerRow = Math.floor(totalMobile / rowsCount);
    const extra = totalMobile % rowsCount;
    let startIndex = 0;

    this.mobileRows.forEach((row, index) => {
      const count = basePerRow + (index < extra ? 1 : 0);
      const endIndex = startIndex + count;

      this.shuffledItems.slice(startIndex, endIndex).forEach((item) => {
        const el = this.#createItem(item);
        if (el) row.appendChild(el);
      });

      startIndex = endIndex;
    });
  }
}

customElements.define('random-items-order', RandomItemsOrder);
